export enum EnrichmentKrameriusJob {
	ENRICHMENT_EXTERNAL = 'ENRICHMENT_EXTERNAL',
	ENRICHMENT_NDK = 'ENRICHMENT_NDK',
	ENRICHMENT_TEI = 'ENRICHMENT_TEI',
}
